import { BoardroomPreview } from "@/components/sections/BoardroomPreview";
import { FinalCta } from "@/components/sections/FinalCta";
import { Hero } from "@/components/sections/Hero";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { PrivacyFirst } from "@/components/sections/PrivacyFirst";
import { ProcessingModes } from "@/components/sections/ProcessingModes";
import { ProductPreview } from "@/components/sections/ProductPreview";
import { Workforce } from "@/components/sections/Workforce";

export function Landing() {
  return (
    <>
      <Hero />
      <ProductPreview />
      <HowItWorks />
      <ProcessingModes />
      <Workforce />
      <PrivacyFirst />
      <BoardroomPreview />
      <FinalCta />
    </>
  );
}
